import LeagueInterface from "interfaces/league";
import moment, { ISO_8601 } from "moment";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import logo from "statics/images/biadi-logo-icon.png";
import * as SBService from "../../helpers/sportbookService";
import { getAssetFullUrl } from "../../helpers/utils";
import { loaderState, userState } from "../../states/common";
import Icon from "../icon";
import TIcon from "../ui/TIcon";
import {LeagueTypeFiltering} from "../../shared/enums/LeagueTypeEnum";

interface LeagueListingItemProps {
  league: any;
  isJoined: boolean;
  isShowScanBtn: boolean;
}

/**
 * Nhãn thể thức giải — luôn cùng một kiểu.
 *
 * Trước đây giải đang diễn ra dùng tag đặc màu đỏ còn lại dùng tag viền mờ, nên
 * cùng một thông tin (thể thức) lại đổi màu theo tab người dùng đang đứng, đọc
 * như thể nó mang ý nghĩa khác. Trạng thái đang diễn ra đã được thể hiện bằng
 * tab và bằng khoảng ngày thi đấu.
 */
const LeagueStatus = ({ league }: { league: LeagueInterface }) => {
  const leagueType = LeagueTypeFiltering.find((el) => el.value == league.type);
  const statusMsg = leagueType ? leagueType.label : "Vòng tròn tính điểm";

  return <span className="tag-ghost">{statusMsg.toUpperCase()}</span>;
};
const NewLeagueListingItem: React.FC<LeagueListingItemProps> = ({
  league,
  isJoined = false,
  isShowScanBtn = false,
}) => {
  const navigate = useNavigate();
  league.startDateObj = moment(league.startDate, ISO_8601);
  league.endDateObj = moment(league.endDate, ISO_8601).endOf('day');
  league.startRegistrationDateObj = moment(
    league.startRegistrationDate,
    ISO_8601
  );
  league.endRegistrationDateObj = moment(league.endRegistrationDate, ISO_8601);
  const [user, setUser] = useRecoilState(userState);
  const [loader, setLoader] = useRecoilState(loaderState);
  const [showModal, setShowModal] = useState(false);
  const [playerInLeague, setPlayerInleague] = useState<any>({
    id: null,
    isCheckin: false,
  });

  const venue = league.venues?.[0] || {};

  //   const now = moment();

  //   const navigateToScanQR = (event: any) => {
  //     event.preventDefault();
  //   };

  const navigateToLeaguePage = () => {
    // Mọi thể thức đều vào chung /league/:id; trang đó tự rẽ nhánh sang màn
    // Swiss khi league.type === 'SWISS'.
    navigate(`/league/${league.id}`);
  };

  const joinLeague = async (event: any) => {
    event.preventDefault();
    setLoader(true);
    let listJoined = user.leagues.map((league) => league.id);
    if (!listJoined.includes(league.id)) {
      try {
        await SBService.joinLeagueById(league.id);
        toast.success("Tham gia giải đấu thành công");
        let userLeagues = [
          ...user.leagues,
          { id: league.id, banner: league.banner, logo: league.logo },
        ];

        setUser({ ...user, leagues: userLeagues });
      } catch (e: any) {
        if (e.response && e.response.data && e.response.data.error) {
          switch (e.response.data.error) {
            case "leagueFull":
              toast.error("Lỗi, giải đã đủ cơ thủ tham gia");
              break;
            default:
              toast.error("Lỗi, " + e.response.data.error);
              break;
          }
        } else {
          toast.error("Không thể tham gia giải đấu");
        }
      }
    } else {
      toast.error("Có lỗi xảy ra: Bạn đã tham gia giải đấu");
    }
    setShowModal(false);
    setLoader(false);
  };

  //   const checkIn = async () => {
  //     setLoader(true);
  //     try {
  //       await SBService.checkinLeagueById(league.id);
  //       setPlayerInleague({ ...playerInLeague, ...{ isCheckin: true } });
  //       toast.success("Check-In thành công");
  //     } catch (e: any) {
  //       toast.error("Check-In thất bại");
  //     }
  //     setLoader(false);
  //   };

  //   const checkOut = async () => {
  //     setLoader(true);
  //     try {
  //       await SBService.checkoutLeagueById(league.id);
  //       setPlayerInleague({ ...playerInLeague, ...{ isCheckin: false } });
  //       toast.success("Check-out thành công");
  //     } catch (e: any) {
  //       toast.error("Check-out thất bại");
  //     }
  //     setLoader(false);
  //   };

  useEffect(() => {
    const loadUserRec = async () => {
      // Chưa tham gia thì chắc chắn không có bản ghi đăng ký - gọi vào chỉ để
      // nhận 404 rồi nuốt, vừa vô ích vừa làm rác tab Network khi soát lỗi.
      if (!isJoined || !user?.id) {
        return;
      }
      try {
        const userRec = await SBService.getPlayerInLeagueData(
          league.id,
          user.id
        );
        if (userRec && userRec.data) {
          setPlayerInleague(userRec.data);
        }
      } catch (e: any) {}
    };

    loadUserRec();
  }, []);

  return (
    <div className="ui-card" style={{ overflow: "hidden" }}>
      {/* Tên địa điểm và địa chỉ trước đây chen chung nửa dòng với nhãn thể
          thức, nên địa chỉ gần như luôn bị cắt. Tách hai dòng: tên đứng cùng
          hàng với nhãn (tên vốn ngắn), địa chỉ chiếm trọn dòng dưới. */}
      <div className="league-card-head">
        <div className="row">
          <span className="venue-name">{venue?.name || "Chưa rõ địa điểm"}</span>
          <LeagueStatus league={league} />
        </div>
        {venue?.address ? <span className="venue-addr">{venue.address}</span> : null}
      </div>

      <div className="event-card" onClick={() => navigateToLeaguePage()}>
        <img
          className="date-box"
          alt=""
          src={league.logo ? getAssetFullUrl(league.logo) : logo}
          style={{ objectFit: "cover" }}
        />
        <div className="info">
          <span className="name">{league.name}</span>
          {league.startDateObj && (
            <span className="meta">
              Thi đấu: {league.startDateObj.format("DD/MM/YY")} –{" "}
              {league.endDateObj.format("DD/MM/YY")}
            </span>
          )}
        </div>
        <span style={{ color: "var(--biadi-steel)", fontSize: 18 }}>
          <TIcon name="chevron-right" />
        </span>
      </div>

    </div>
  );
};

export default NewLeagueListingItem;
